import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import MagicLinkSent from '@/pages/Onboarding/components/MagicLinkSent/MagicLinkSent';
import { Product, getTheme, getProductKey } from '@/utils/productHelpers';
import { activateEmail } from '@/utils/sparkActivationApi';
import LimbotHoldingPhone from '@/assets/LimbotHoldingPhone.svg';
import SleepioThumbsUp from '@/assets/SleepioThumbsUp.svg';

const PRODUCT_HERO: Record<string, { src: string; alt: string }> = {
  spark: { src: LimbotHoldingPhone, alt: 'Spark Limbot holding phone' },
  sleepio: { src: SleepioThumbsUp, alt: 'Sleepio Thumbs Up' },
};

interface MagicLinkSentLocationState {
  email?: string;
  accessCode?: string;
  organizationSlug?: string;
}

const MagicLinkSentPage: React.FC = () => {
  const { product } = useParams<{ product: Product }>();
  const { state: locationState } = useLocation<MagicLinkSentLocationState>();
  const { t } = useTranslation();
  const productKey = getProductKey(product);
  const hero = PRODUCT_HERO[productKey] || PRODUCT_HERO.sleepio;

  const handleResend = async (email: string) => {
    try {
      await activateEmail({
        email,
        product,
        accessCode: locationState?.accessCode,
        organizationSlug: locationState?.organizationSlug,
      });
      return { success: true };
    } catch {
      return { success: false };
    }
  };

  return (
    <ThemeProvider theme={getTheme(product)}>
      <MagicLinkSent
        imageSrc={hero.src}
        imageAlt={hero.alt}
        title={t(`coverage.pre_onboarding.magic_link_sent.${productKey}.title`)}
        description={t(`coverage.pre_onboarding.magic_link_sent.${productKey}.description`)}
        cantFindTitle={t(`coverage.pre_onboarding.magic_link_sent.${productKey}.cant_find_title`)}
        cantFindDescription={t(`coverage.pre_onboarding.magic_link_sent.${productKey}.cant_find_description`)}
        email={locationState?.email || ''}
        onResend={handleResend}
        buttonLabel={t(`coverage.pre_onboarding.magic_link_sent.${productKey}.button`)}
      />
    </ThemeProvider>
  );
};

export default MagicLinkSentPage;
